module.exports = __webpack_public_path__ + "img/minus.58f8da55.svg";